// extracted by mini-css-extract-plugin
export default {"feature":"Features_feature__tfLnU","titulo":"Features_titulo__CUPCf","paragrafo":"Features_paragrafo__o2H9v","tab":"Features_tab__GFTrQ"};